import { useEffect, useState } from "react";
import { fetchMe } from "../api/me";

/**
 * Whether the signed-in user is a distribution API admin (ADMIN_UID on server).
 * @param {object} auth_user
 * @returns {{ loaded: boolean, isAdmin: boolean }}
 */
export function useIsAdmin(auth_user) {
  const [state, setState] = useState({ loaded: false, isAdmin: false });

  useEffect(() => {
    if (!auth_user?.user?.uid) {
      setState({ loaded: true, isAdmin: false });
      return undefined;
    }
    let cancelled = false;
    fetchMe().then((data) => {
      if (cancelled) return;
      setState({ loaded: true, isAdmin: Boolean(data.isAdmin) });
    });
    return () => {
      cancelled = true;
    };
  }, [auth_user?.user?.uid]);

  return state;
}
